import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Router from 'next/router';
import { NavBar } from './components/NavBar';
import { Banner } from './components/Banner';
import { Skills } from './components/Skills';
import { Projects } from './components/Projects';
import { Footer } from './components/Footer';
import { Experience } from './components/Experience';
import * as gtag from './lib/gtag';
import { LanguageButton } from './components/LanguageButton';

Router.events.on('routeChangeComplete', (url) => gtag.pageview(url));

function App() {
  return (
    <div className="App">
      <NavBar />
      <Banner />
      <Skills />
      <Projects />
      <Experience />
      <Footer />
      <LanguageButton />
    </div>
  );
}

export default App;
